var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-content"},[_c('div',{staticClass:"m-portlet m-portlet--full-height m-portlet--tabs  "},[_c('div',{staticClass:"tab-content"},[_c('integration-settings')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }